import { Target, targetLogosMap } from './constants/targets';

export const TargetIcon = ({ target }: { target: Target }) => {
  const Icon = targetLogosMap[target.logoKey];
  return (
    <div className='shadow-tiny bg-neutral-N00 flex h-8 w-8 shrink-0 items-center justify-center rounded-full'>
      <Icon className='h-full w-full' />
    </div>
  );
};
